import React from 'react';
import { Redirect } from 'react-router-dom';

export default function Support() {
  return <Redirect to="/support.pdf" />;
}
